import { axios, Response } from '../index'

type Body = {
  newInviteStatus: string
}

const acceptInvite = (
  groupId: string,
  inviteId: string,
  body: Body
): Response<Body> => {
  return axios.put(`/v1/groups/invite/${inviteId}`, body)
}

export default acceptInvite
